import React from 'react';

interface PriceUpIconProps {
  className?: string;
}

const PriceUpIcon: React.FC<PriceUpIconProps> = ({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_9674_11156)">
        <path d="M15.2019 8.97519C14.9898 8.97519 14.7863 8.8909 14.6362 8.74087C14.4862 8.59084 14.4019 8.38736 14.4019 8.17519V6.10319L9.69793 10.8072C9.54804 10.9562 9.34528 11.0398 9.13393 11.0398C8.92258 11.0398 8.71982 10.9562 8.56993 10.8072L5.76193 7.99919L1.36993 12.3912C1.21929 12.5418 1.01497 12.6265 0.801931 12.6265C0.588889 12.6265 0.384573 12.5418 0.233931 12.3912C0.0832876 12.2405 -0.00134277 12.0362 -0.00134277 11.8232C-0.00134277 11.6101 0.0832876 11.4058 0.233931 11.2552L5.19393 6.29519C5.34382 6.14619 5.54658 6.06255 5.75793 6.06255C5.96928 6.06255 6.17204 6.14619 6.32193 6.29519L9.12993 9.10319L13.2659 4.96719H11.2019C10.9898 4.96719 10.7863 4.8829 10.6362 4.73287C10.4862 4.58284 10.4019 4.37936 10.4019 4.16719C10.4019 3.95501 10.4862 3.75153 10.6362 3.6015C10.7863 3.45147 10.9898 3.36719 11.2019 3.36719H15.2019C15.4141 3.36719 15.6176 3.45147 15.7676 3.6015C15.9176 3.75153 16.0019 3.95501 16.0019 4.16719V8.16719C16.003 8.27292 15.9831 8.37781 15.9433 8.47579C15.9036 8.57378 15.8449 8.66292 15.7705 8.73805C15.6961 8.81319 15.6075 8.87283 15.5099 8.91354C15.4124 8.95424 15.3077 8.97519 15.2019 8.97519Z" fill="#14C784"/>
      </g>
      <defs>
        <clipPath id="clip0_9674_11156">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default PriceUpIcon;


